// extracted by mini-css-extract-plugin
module.exports = {"CurrentPost":"CurrentPost_CurrentPost__3PC9t"};